export const APP_DETAILS = {
  FA_NAME: 'فیلیمو',
  EN_NAME: 'Filimo',
  AR_NAME: 'فیلیمو',
  TJ_NAME: 'Filimo',
  FA_DESCRIPTION: 'فیلیمو تی وی',
  EN_DESCRIPTION: 'Filimo TV',
  AR_DESCRIPTION: 'فیلیمو تی وی',
  TJ_DESCRIPTION: 'Filimo телевизион',
};

export const APP_API = {
  PROXY_URL: 'https://www.filimo.com',
  API_PROTOCOL: 'https',
  API_SUBDOMAIN: 'www',
  API_BASE: 'filimo.com',
  API_PATH: 'api',
  API_VERSION: 'v1',
};

export const APP_GLOBAL_CONFIG = {
  APP_VERSION: '3.9.103',
  ROWS_PER_PAGE: 5,
  GOOGLE_TAG_MANAGER: 'GTM-KLQGVK8',
  LOGIN_URL: 'https://filimo.com/activate',
  APPS_URL: 'https://filimo.com/app',
};
